module.exports = __webpack_public_path__ + "media/images/svg-icon/dashboard-35a56f86690224bb2a96a1469c9a23ef.svg";